module.exports = __webpack_public_path__ + "assets/img/Record_btn.f2afa796.png";